import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function TeanContentReducer(state = initialState.teamContent, action: any) {
  switch (action.type) {
    case types.SAVE_TEAMCONTENT_SUCCESS:
      return action.teamContent;
    default:
      return state;
  }
}
